import { Module } from "@/interfaces/module";
import { stateModule } from "@/interfaces/module";

const module: Module = {
  namespaced: true,
  state: {
    name: ""
  },
  mutations: {
    setModule(state: stateModule, data: string) {
      state.name = data;
    },
    clearModule(state: stateModule) {
      state.name = "";
    }
  }
};

export default module;
